import React,{useEffect} from "react";
import { TextField } from "@mui/material";
import {
  MetricsMainWrapper,
  BannerSection,
  BannerContent,
  BannerTitle,
  MetricsBody,
  FilterWrapper,
  MetricsGrid,
  MetricCard,
  MetricValue,
  MetricLabel,
  MetricIcon
} from "./MetricsContent.styles";
import { useDispatch, useSelector } from "react-redux";
import { fetchMetrics } from "../../store/metricsSlice";
function MetricsContent() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMetrics())
  }, [dispatch]);

  const {metrics, loading} = useSelector((state) => state.metrics);
  return (
    <MetricsMainWrapper>

      <BannerSection sx={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/Metrics/Metrics-Banner.png)`}}>
        <BannerContent>
          <BannerTitle>
            Community of Learning Metrics
          </BannerTitle>
        </BannerContent>
      </BannerSection>

      <MetricsBody>

        {/* <FilterWrapper>
            <TextField
              size="small"
              placeholder="Filter by"
              className="custom-select filter-select"
              sx={{
                minWidth: 160,
                "& .MuiOutlinedInput-root": {
                  height: 35,
                  borderRadius: 0,
                  fontSize: "14px",
                },
                "& .MuiInputBase-input": {
                  padding: "10px 10px",
                  fontSize: "14px",
                },
              }}
            />
        </FilterWrapper> */}

        <MetricsGrid>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
                <MetricValue>{metrics?.totalPosts || 0}</MetricValue>
              )}
              <MetricLabel>Total Posts</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/TotalPosts-icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.activeUsers || 0}</MetricValue>
              )}
              <MetricLabel>Active Users</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/ActiveUsers-icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.questionsAsked || 0}</MetricValue>
              )}
              <MetricLabel>Questions Asked</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/QuestionAsked-icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.expertAnswers || 0}</MetricValue>
              )}
              <MetricLabel>Expert Answers</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/ExpertAnswers-icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.bestAnswers || 0}</MetricValue>
              )}
              <MetricLabel>Best Answers</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/BestAnswer-icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.likesReceived || 0}</MetricValue>
              )}
              <MetricLabel>Likes received</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/LikesReceived-icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.commentsReceived || 0}</MetricValue>
              )}
              <MetricLabel>Comments Received</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/comments_icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.activeQueries || 0}</MetricValue>
              )}
              <MetricLabel>Active Queries</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/ActiveQueries-icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.unansweredQueries || 0}</MetricValue>
              )}
              <MetricLabel>Unanswered Queries</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/UnansweredQueries-icon.png`} />
          </MetricCard>

          <MetricCard>
            <div>
              {loading ? (
                <MetricValue sx={{ fontSize: "14px" }}>Loading...</MetricValue>
              ) : (
              <MetricValue>{metrics?.archivedQueries || 0}</MetricValue>
              )}
              <MetricLabel>Archived Queries</MetricLabel>
            </div>
            <MetricIcon src={`${process.env.PUBLIC_URL}/images/Metrics/ArchivedQueries-icon.png`} />
          </MetricCard>

        </MetricsGrid>
      </MetricsBody>

    </MetricsMainWrapper>
  );
}

export default MetricsContent;
